import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
    return (
        <div className="min-h-screen flex items-center justify-center bg-[#f7f8fa]">
            <div className="text-center">
                <div className="text-7xl font-bold text-aks-navy">404</div>
                <p className="mt-2 text-gray-500">Page not found</p>
                <Link to="/dashboard" className="mt-6 inline-block px-4 py-2 rounded-md bg-aks-gold text-aks-navy font-semibold">Back to dashboard</Link>
            </div>
        </div>
    );
}
